export default function GiftRedeemedSuccessfully(): React.ReactElement {
  return (
    <p className="font-poppins text-base">
      {"Enjoy this premium story from your sender!"}
    </p>
  );
}
